import { readEnv } from "./env";

export const CX_API_URL = readEnv("VITE_CX_API_URL", "");

export function buildCxApiUrl(path: string): string {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  const baseUrl = CX_API_URL.endsWith("/")
    ? CX_API_URL.slice(0, -1)
    : CX_API_URL;

  return `${baseUrl}${normalizedPath}`;
}

export const CX_API_ENDPOINTS = {
  HEALTH: "/healthz",
  CATALOG: "/api/cx/v1/reference/catalog",
  PUBLIC_TENANT_RESOLVE: "/api/cx/v1/public/tenants/resolve",
  PUBLIC_REFERRALS: "/api/cx/v1/public/referrals",
  PUBLIC_REFERRAL: (referralCode: string) =>
    `/api/cx/v1/public/referrals/${encodeURIComponent(referralCode)}`,
  PUBLIC_REFERRAL_CLAIM: (referralCode: string) =>
    `/api/cx/v1/public/referrals/${encodeURIComponent(referralCode)}/claim`,
  PUBLIC_REFERRAL_ACCESS: (accessToken: string) =>
    `/api/cx/v1/public/referral-access/${encodeURIComponent(accessToken)}`,
  PUBLIC_SURVEY: (appointmentCode: string) =>
    `/api/cx/v1/public/surveys/${encodeURIComponent(appointmentCode)}`,
  PUBLIC_SURVEY_LINK_OPEN: (surveyCode: string) =>
    `/api/cx/v1/public/surveys/${encodeURIComponent(surveyCode)}/link-opens`,
  PUBLIC_SURVEY_REVIEW_CLICK: (surveyCode: string) =>
    `/api/cx/v1/public/surveys/${encodeURIComponent(surveyCode)}/review-clicks`,
  PUBLIC_SURVEY_REVIEW_LINK_OPEN: (surveyCode: string) =>
    `/api/cx/v1/public/surveys/${encodeURIComponent(surveyCode)}/review-link-opens`,
  PUBLIC_SURVEY_STRIPE_TIP_CONFIG: (surveyCode: string) =>
    `/api/cx/v1/public/surveys/${encodeURIComponent(surveyCode)}/tips/stripe/config`,
  PUBLIC_SURVEY_STRIPE_TIP_CHECKOUT: (surveyCode: string) =>
    `/api/cx/v1/public/surveys/${encodeURIComponent(surveyCode)}/tips/stripe/checkout-sessions`,
  PUBLIC_SURVEY_STRIPE_TIP_CONFIRM: (surveyCode: string, sessionId: string) =>
    `/api/cx/v1/public/surveys/${encodeURIComponent(surveyCode)}/tips/stripe/checkout-sessions/${encodeURIComponent(sessionId)}/confirm`,
} as const;
